import { createIsomorphicFn } from '@tanstack/react-start'
import { getRequest } from '@tanstack/react-start/server'

// Emitted in the server HTML because React hoists app.css above the inline manageTheme script, which then runs
// too late and the browser paints light first.
// The CLIENT variant reads the same cookie and is NOT a no-op: the root loader re-runs, and returning null there
// would strip the `dark` class React painted at SSR. In system mode it is null on both sides, so manageTheme keeps it.
const cookieTheme = (cookie: string): 'dark' | 'light' | null => {
  if (/(?:^|;\s*)theme=dark(?:;|$)/.test(cookie)) return 'dark'
  if (/(?:^|;\s*)theme=light(?:;|$)/.test(cookie)) return 'light'
  return null
}

export const resolveServerTheme = createIsomorphicFn()
  .server((): 'dark' | 'light' | null => cookieTheme(getRequest().headers.get('cookie') ?? ''))
  .client((): 'dark' | 'light' | null => cookieTheme(typeof document === 'undefined' ? '' : document.cookie))
